import React, { Component } from 'react';
import Switch from "react-switch";
import Select from 'react-select';

import { Oferta, ConsultOferta, ConsultPeriodos } from '../../funciones/OfertaFunction';
import { toast } from 'react-toastify';

class OfertaTable extends Component {
    state = {
        valorProfe: this.props.campos.prof,
        profesores: this.props.profes,
        check: "",
        preloader: "fa fa-circle-o",
        periodoSelect: {value:"", label: "- Selecciona un Periodo -"},
        periodos: [],
    }

    componentWillMount = () => {
        setTimeout(() => {
            ConsultOferta(this.props.campos.id, (resp) => {
                this.setState(resp)
            })
    
            ConsultPeriodos((resp) => {
                this.setState({
                    periodos: resp
                })
            })   
        }, this.props.time);
    }

    check = () => {
        let { check } = this.state;
        if (check === "") return <i className="fa fa-spinner fa-spin"></i>
        return <Switch height={12} width={24} onChange={this.cambiacheck} checked={check} />
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:(event.target.value).toUpperCase(),
            },
        });
    };

    valorProfe = (valorProfe) => { this.setState({valorProfe}) }
    valorPeriodo = (periodoSelect) => { this.setState({periodoSelect}) }

    cambiacheck= () => {
        this.setState({
            check: !this.state.check,
            preloader: "fa fa-spinner fa-spin"
        }, () => {
            let { check, valorProfe, periodoSelect  } = this.state
            Oferta(this.props.campos.id, periodoSelect, check, valorProfe.value, (resp) => {
                if (resp > 0) {
                    toast.error("No se pudo aperturar la sección porque no selecionó un Periodo",{autoClose: 4000});
                    this.setState({
                        preloader: "fa fa-circle-o",
                        check: false,
                    })
                }else{
                    this.setState({
                        preloader: "fa fa-check",
                    })
                }

                ConsultOferta(this.props.campos.id, (resp) => {
                    this.setState(resp)
                })
            })
        })
    }

    render() {
        let { campos } = this.props;
        
        let { valorProfe, profesores, preloader, periodos, periodoSelect } = this.state;
        const styles = {
            padding: 8, fontSize: 12
        }
        const stylesSecc = {
            padding: 8, fontSize: 10
        }
        const stylesStatus = {
            padding: 0, fontSize: 10
        }
        const customStyles = (base) => ({
            ...base,
            fontSize: 12,
        });

        return (
            <tr>
                <td width="25px" style={stylesStatus} align= "center"><i className={preloader} style={{color:"#326432"}}></i></td>
                <td style={stylesSecc}>
                    {campos.seccion}
                    <div className='text-primary'>{campos.observ}</div>
                </td>
                <td style={styles}>
                    <Select
                        styles={{menu: customStyles}}
                        isSearchable ={true}
                        value={valorProfe}
                        onChange={this.valorProfe}
                        options={profesores}
                    />
                </td>
                <td style={styles}>
                    <Select
                        styles={{menu: customStyles}}
                        isSearchable ={true}
                        value={periodoSelect}
                        onChange={this.valorPeriodo}
                        options={periodos}
                    />
                </td>
                <td style={styles} align= "center" title= "Haz click aqui para agregar o quitar una seccion de la oferta académica">
                    {this.check()}
                </td>
            </tr>
        );
    }
}
 
export default OfertaTable;


// WEBPACK FOOTER //
// ./src/views/Secciones/OfertaTable.jsx